export const CLEAR_HISTORY_STATE = 'CLEAR_HISTORY_STATE';
export const ADD_HOLE_CARDS_HISTORY_ENTRY = 'ADD_HOLE_CARDS_HISTORY_ENTRY';
export const ADD_COMMUNITY_CARDS_HISTORY_ENTRY = 'ADD_COMMUNITY_CARDS_HISTORY_ENTRY';
export const ADD_TEXT_HISTORY_ENTRY = 'ADD_TEXT_HISTORY_ENTRY';
export const ADD_HTML_HISTORY_ENTRY = 'ADD_HTML_HISTORY_ENTRY';
export const ADD_REVEALED_CARDS_HISTORY_ENTRY = 'ADD_REVEALED_CARDS_HISTORY_ENTRY';
export const ADD_SIDE_BETS_SUMMARY_HISTORY_ENTRY = 'ADD_SIDE_BETS_SUMMARY_HISTORY_ENTRY';
export const ADD_HAND_END_HISTORY_ENTRY = 'ADD_HAND_END_HISTORY_ENTRY';
export function clearHistoryState() {
    return {
        type: CLEAR_HISTORY_STATE
    };
}
export function addHoleCardsHistoryEntry(cards) {
    return {
        type: ADD_HOLE_CARDS_HISTORY_ENTRY,
        payload: cards
    };
}
export function addCommunityCardsHistoryEntry(cards, newBetRoundNumber) {
    return {
        type: ADD_COMMUNITY_CARDS_HISTORY_ENTRY,
        payload: { cards, newBetRoundNumber }
    };
}
export function addTextHistoryEntry(text, headerType) {
    return {
        type: ADD_TEXT_HISTORY_ENTRY,
        payload: { text, headerType }
    };
}
export function addHtmlHistoryEntry(html) {
    return {
        type: ADD_HTML_HISTORY_ENTRY,
        payload: html
    };
}
export function addRevealedCardsHistoryEntry(cards, username) {
    return {
        type: ADD_REVEALED_CARDS_HISTORY_ENTRY,
        payload: { cards, username }
    };
}
export function addSideBetsSummaryHistoryEntry(jacksWonPerWinner, winners, losers) {
    return {
        type: ADD_SIDE_BETS_SUMMARY_HISTORY_ENTRY,
        payload: { jacksWonPerWinner, winners, losers }
    };
}
export function addHandEndHistoryEntry() {
    return {
        type: ADD_HAND_END_HISTORY_ENTRY
    };
}
